import './../styles/code.css';
import KONAMI_LOGO from './../assets/images/konami-logo.png';
import { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import ToastNotification, { showTopCenterToast } from '../components/toasts/ToastNotification';
import { getOtpCode } from '../api/gmail.api';
import OtpCodeModal from '../components/modal/otp-code-modal';
import { FiExternalLink, FiShield, FiZap } from 'react-icons/fi';

export const Code = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [otpCode, setOtpCode] = useState("");

    const handleRetrieveCode = async () => {
        try {
            setLoading(true);

            if (!email || !password) {
                showTopCenterToast("Vui lòng điền vào các trường", "error");
                setLoading(false);
                return;
            }

            const res = await getOtpCode(email, password);

            if (res.success) {
                setIsModalOpen(true);
                setOtpCode(res.data.otp);
            }
        } catch (error) {
            showTopCenterToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <div className='code-page-shell'>
            <ToastNotification />
            <OtpCodeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} otp={otpCode} />

            <div className='code-page-layout'>
                <section className='code-page-panel code-page-panel-guide'>
                    <div className='code-page-logo-wrap'>
                        <img className='code-page-logo' src={KONAMI_LOGO} alt='Konami Logo' />
                    </div>

                    <p className='code-page-kicker'>Konami Security Center</p>
                    <h2 className='code-page-title'>Lấy mã xác thực tài khoản</h2>
                    <p className='code-page-subtitle'>
                        Nhập đúng Gmail dùng cho Konami để nhận OTP nhanh, giúp đổi thông tin tài khoản an toàn.
                    </p>

                    <div className='code-page-steps'>
                        <div className='code-page-step-item'>
                            <span className='code-page-step-index'>01</span>
                            <p>
                                Truy cập trang Konami và mở phần thay đổi thông tin.
                                <button
                                    type='button'
                                    className='code-page-link-btn'
                                    onClick={() => window.open("https://my.konami.net/en_GB", "_blank", "noopener,noreferrer")}
                                >
                                    Mở trang Konami <FiExternalLink />
                                </button>
                            </p>
                        </div>
                        <div className='code-page-step-item'>
                            <span className='code-page-step-index'>02</span>
                            <p>Nhập email + mật khẩu Gmail vào form bên phải, sau đó bấm lấy mã.</p>
                        </div>
                        <div className='code-page-step-item'>
                            <span className='code-page-step-index'>03</span>
                            <p>Copy OTP và dán vào form xác minh trên Konami để hoàn tất.</p>
                        </div>
                    </div>

                </section>

                <section className='code-page-panel code-page-panel-form'>
                    <h3 className='code-page-form-title'>Nhập thông tin Gmail</h3>
                    <p className='code-page-form-subtitle'>Hệ thống chỉ dùng để truy vấn OTP, không thay đổi tài khoản của bạn.</p>

                    <div className='code-page-form-grid'>
                        <label htmlFor='konami-email' className='code-page-field-label'>Email</label>
                        <input
                            id='konami-email'
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            type='email'
                            className='code-page-input'
                            placeholder='example@gmail.com'
                            autoComplete='username'
                        />

                        <label htmlFor='konami-password' className='code-page-field-label'>Mật khẩu</label>
                        <input
                            id='konami-password'
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            type='password'
                            className='code-page-input'
                            placeholder='Nhập mật khẩu Gmail'
                            autoComplete='current-password'
                        />
                    </div>

                    <button
                        onClick={handleRetrieveCode}
                        disabled={loading}
                        className='code-page-submit-btn'
                        type='button'
                    >
                        {loading ? <ClipLoader size={20} color='#fff' /> : "Lấy mã OTP"}
                    </button>
                </section>
            </div>
        </div>
    );
}
